module.exports = __webpack_public_path__ + "static/media/6.f4d0d373.jpg";